export const isSupport = (url) => {
    // static.yximgs和cdnfile.corp.kuaishou不支持
    return (!/https?:\/\/static.yximgs.com/i.test(url) &&
        !/https?:\/\/cdnfile.corp.kuaishou.com/i.test(url) &&
        /\.(jpe?g|png|webp|gif|bmp|tiff)/i.test(url));
};
export const isSupportResize = (url) => {
    return /\.(jpe?g|png|webp|gif)$/i.test(url);
};
export const isSupportQuality = (url) => {
    return /\.(jpe?g|webp)$/i.test(url);
};
export const isSupportInterlace = (url) => {
    return /\.(jpe?g|webp)$/i.test(url);
};
